var _title, _defs, _g, _rect, _path, _g2, _rect2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDriverLicenseAndIdGraphic = function SvgDriverLicenseAndIdGraphic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "218px",
    height: "149px",
    viewBox: "0 0 218 125",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "foundation/icon/dps/driver license and id graphic")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 8.5,
    y: 8.61971831,
    width: 198.253521,
    height: 127.140845,
    rx: 5.02816901
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-10.6%",
    width: "116.6%",
    height: "126.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.198312953 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.26544331%",
    y1: "60.3463021%",
    x2: "98.815407%",
    y2: "41.9901636%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDECF5",
    offset: "50.2239948%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF5E5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08A8A",
    offset: "36.2473478%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "68.7172203%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Foundations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TexKit_Foundations_7",
    transform: "translate(-560.000000, -3049.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_DL-and-ID-Graphic",
    transform: "translate(561.000000, 3049.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F0F0F0",
    xlinkHref: "#path-1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 215,
    height: 136,
    rx: 5.02816901
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199,8 C203.418278,8 207,11.581722 207,16 C207,20.418278 203.418278,24 199,24 C194.581722,24 191,20.418278 191,16 C191,11.581722 194.581722,8 199,8 Z M199,10 L197.307178,13.6700311 L193.293661,14.145898 L196.260957,16.8899689 L195.473288,20.854102 L199,18.88 L202.526712,20.854102 L201.739043,16.8899689 L204.706339,14.145898 L200.692822,13.6700311 L199,10 Z",
    id: "Combined-Shape",
    fill: "#E7C37A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Texas-flag",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#20294F",
    points: "0.509644172 15.4705069 22.8176763 15.4705069 22.8176763 0.520443884 0.509644172 0.520443884"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFE",
    points: "7.97958282 7.99543001 22.8596281 7.99543001 22.8596281 0.520383354 7.97958282 0.520383354"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#A82439",
    points: "7.97958282 15.4704464 22.8596281 15.4704464 22.8596281 7.99546028 7.97958282 7.99546028"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-8",
    fill: "#FFFFFE",
    points: "4.22768476 5.52436822 4.86010382 7.3612913 6.87110524 7.41207566 5.30450967 8.64424716 5.86145163 10.4665221 4.23514488 9.31309962 2.59400849 10.4665221 3.17970363 8.64424716 1.58432468 7.41207566 3.596353 7.34758134 4.22768476 5.52436822"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(71.000000, 44.000000)",
    fill: "#D4E0FC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-2",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 10,
    width: 56,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-3",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 20,
    width: 40,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-4",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 30,
    width: 40,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-10",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 46,
    width: 56,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-11",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 52,
    width: 40,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-6",
    style: {
      mixBlendMode: "multiply"
    },
    x: 72,
    y: 0,
    width: 32,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-8",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 0,
    width: 56,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-7",
    style: {
      mixBlendMode: "multiply"
    },
    x: 72,
    y: 10,
    width: 24,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-23",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 68,
    width: 32,
    height: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "url(#linearGradient-4)",
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(175.000000, 106.000000) rotate(-32.000000) translate(-175.000000, -106.000000) ",
    points: "175 120.08 171.439665 121.598847 168.890917 118.685642 165.024163 118.509304 163.991813 114.778736 160.584498 112.94214 161.273015 109.133095 159 106 161.273015 102.866905 160.584498 99.0578602 163.991813 97.2212636 165.024163 93.4906963 168.890917 93.3143583 171.439665 90.4011534 175 91.92 178.560335 90.4011534 181.109083 93.3143583 184.975837 93.4906963 186.008187 97.2212636 189.415502 99.0578602 188.726985 102.866905 191 106 188.726985 109.133095 189.415502 112.94214 186.008187 114.778736 184.975837 118.509304 181.109083 118.685642 178.560335 121.598847"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PHOTO",
    transform: "translate(8.000000, 44.000000)",
    fillRule: "nonzero"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 53,
    height: 72,
    rx: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Driver-License-Icon",
    transform: "translate(0.335833, 0.649716)",
    fill: "#D4E0FC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoulders-+-BG",
    transform: "translate(0.000000, 30.663252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6641668,23.3436986 L51.6641668,15.6870313 L51.6641668,15.6870313 C51.6641668,7.40276003 45.3215341,0.687031279 37.4975002,0.687031279 L14.8308335,0.687031279 C7.00679953,0.687031279 0.664166819,7.40276003 0.664166819,15.6870313 L0.664166819,23.3436986 C0.664166819,24.0856007 1.26559737,24.6870313 2.00749954,24.6870313 L50.3208341,24.6870313 C51.0627363,24.6870313 51.6641668,24.0856007 51.6641668,23.3436986 Z",
    id: "Combined-Shape-Copy",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26,28 C18.2680135,28 12,21.7319865 12,14 C12,6.2680135 18.2680135,0 26,0 C33.7319865,0 40,6.2680135 40,14 C40,21.7319865 33.7319865,28 26,28 Z",
    id: "Oval-Copy",
    style: {
      mixBlendMode: "multiply"
    }
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDriverLicenseAndIdGraphic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/driver-license-and-id-graphic.67a60b6f.svg";
export { ForwardRef as ReactComponent };